import React from 'react';
import ReactDOM from 'react-dom';
import SpecialDishItem from './SpecialDishItem';

const SpecialDishItems = (props) => {
    return (
        props.items.map((item, i)=>{
            return (
                <li key={item.ITEMID}>
                    <div className="item">
                        <div className="veg-non">
                            <img src={`/assets/img/${item.TYPE}.svg`} alt={item.TYPE}/> 
                        </div>
                        <div className="imageWrapper"> 
                            {item.PIC!='' && <img src={item.PIC} alt={item.ITEMNAME} className="imaged w64"/> }
                            {item.PIC=='' && <img src={`/assets/img/default.gif`} alt={item.ITEMNAME} className="imaged default"/> }
                        </div>
                        <div className="in">
                            <div> {item.ITEMNAME}
                                {/*<div className="text-muted">&#8377; 360</div>*/}
                                <div className="text-price">&#8377; {item.RATE}</div>
                            </div>
                            {props.CLOSED=='N' && item.NEXTAVAILABLE=='' && <SpecialDishItem id={item.ITEMID} item={item.ITEMNAME} custom={item.CUSTOM_EXIST} customData={item.CUSTOM} inCartCallBack2={props.inCartCallBack}/> }
                            {props.CLOSED=='N' && item.NEXTAVAILABLE!='' && <div className="aditions" ><div className="openned"><p class="available" dangerouslySetInnerHTML={{ __html: item.NEXTAVAILABLE }} /></div></div>}
                        </div>
                    </div>
                </li>
            )
        })
    );
}
      
export default SpecialDishItems;


// WEBPACK FOOTER //
// ./src/components/SpecialDishItems.js